(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('CompanyAlertDialogController',CompanyAlertDialogController);

    CompanyAlertDialogController.$inject = ['$scope','$stateParams', '$uibModalInstance', 'AlertMasterService','companyName','companyCode','controllerModule','AlertService','parentAccess'];

    function CompanyAlertDialogController ($scope,$stateParams, $uibModalInstance,AlertMasterService,companyName,companyCode,controllerModule,AlertService,parentAccess) {
        var vm = this;       
        vm.clear = clear;
        vm.setAlertForCompany = setAlertForCompany;
        vm.alertActionFlag = 'Y';
        vm.companyCode = companyCode;
        vm.companyName = companyName;
        


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function setAlertForCompany(){       	
        	
        	AlertMasterService.setCompanyAlert.setAlert(
					{companyCode : vm.companyCode, actionFlag : vm.alertActionFlag },
					function(result) {						
						AlertService.info(result.message);
						if(controllerModule == 'companyProfile' ||controllerModule == 'creditSensitivityLanding'||controllerModule == 'creditRiskIndicatorLanding'){							
							parentAccess.getCompanyDetails();
						}
					});
        	$uibModalInstance.dismiss('cancel');
        }
    }
})();
